<h3>Configuration</h3>

<div *ngIf="dataLoaded">

    <h4>Stages</h4>

    <div class="mb-4">
        <h4>Lists current in use</h4>

        <p-table [value]="getLists()"
                 [tableStyle]="{ 'min-width': '50rem' }">

            <ng-template #body let-list>

                <tr *ngIf="!list.closed && !list.detached">

                    <td class="w-1/4">{{ list.name }}</td>
                    <td class="w-1/2">

                        <p-select [options]="options"
                                  [(ngModel)]="selectedListStages[list.listId]"
                                  (ngModelChange)="onListStageChange(list.listId, $event)"
                                  optionLabel="name"
                                  optionValue="value"
                                  styleClass="w-1/2"/>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <div class="mb-4">
        <h4>Lists previously in use</h4>

        <p-table [value]="getLists()"
                 [tableStyle]="{ 'min-width': '50rem' }">

            <ng-template #body let-list>

                <tr *ngIf="list.closed || list.detached">

                    <td class="w-1/4">{{ list.name }}</td>
                    <td class="w-1/2">

                        <p-select [options]="options"
                                  [(ngModel)]="selectedListStages[list.listId]"
                                  (ngModelChange)="onListStageChange(list.listId, $event)"
                                  optionLabel="name"
                                  optionValue="value"
                                  styleClass="w-1/2"/>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <!-- temporary hack to allow select options to render on-screen -->
    <br class="pb-96"/>
    <br class="pb-96"/>
    <br class="pb-96"/>
    <br class="pb-96"/>
    <br class="pb-96"/>
    <br class="pb-96"/>
    <br class="pb-96"/>

</div>
